import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonRadioGroupModule, FormValidationModule, UtilsModule } from '@tablesready/common-ui';
import { OrganizationComponent } from './organization.component';
import {
  DataRetentionComponent,
  ExportDataComponent,
  ExportHistoryComponent,
  OrganizationDataComponent,
} from './components';
import { SortByPipe } from './pipes/sort-by';
import { OrganizationRoutingModule } from './organization.routing.module';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    OrganizationComponent,
    DataRetentionComponent,
    ExportDataComponent,
    OrganizationDataComponent,
    ExportHistoryComponent,
    SortByPipe,
  ],
  imports: [
    CommonRadioGroupModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormValidationModule,
    NgbModule,
    OrganizationRoutingModule,
    FrontendIconsModule,
    UtilsModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
  ],
  exports: [OrganizationComponent],
})
export class OrganizationModule {}
